(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
